<ion-buttons>
    <ion-button (click)="showingPasswordChanged.emit((showingPassword = !showingPassword))">
        <ion-icon
            [name]="showingPassword ? 'eye-off-outline' : 'eye-outline'"
            size="small"
            slot="icon-only"
        ></ion-icon>
    </ion-button>
</ion-buttons>
